<template>
	<div class="check-page">
		<Head position="absolute" mode="white" :isHaveBack="true" @back="backHead"></Head>
		<!-- 横幅 -->
		<div class="banner">
			<div class="content w1360 animate__animated animate__fadeInUp">
				<div class="heading">{{fuwuInfo.title || ''}}</div>
<!-- 				<div class="heading">精准核算碳足迹，为低碳转型注入新动能</div> -->
				<!-- <div class="des">追溯碳足迹，每一步都为地球减 “碳” 加分</div> -->
				<div class="btns">
					<el-button class="lijishiyong" type="whitetrans" @click="apply">立即申请</el-button>
				</div>
			</div>
		</div>
		<!-- 服务介绍 -->
		<div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="serviceIntroduce">
				<div class="serviceIntroduce-container w1200">
					<div class="heading">服务介绍</div>
					<div class="heading-des">
						按照“统一标准、统一模型、统一数据库”，依据ISO14067、GB/T 24067以及T/CCIASD10015—2025《温室气体 产品碳足迹量化方法与要求 集装箱》等标准，搭建行业统一的集装箱产品以及上游供应链产品的碳足迹核算模型，内置国际知名商业数据库Ecoinvent和高质量本土数据库<span style="white-space: nowrap;">HiQLCD</span>，实现产品碳足迹核算的申请、数据输入及导入、数据质量检查、碳足迹计算、碳足迹报告自动生成。
					</div>
				</div>
			</div>
		</div>
		<!-- 步骤 -->
		<div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="steps">
				<div class="steps-container w1200">
					<div class="heading">集装箱产业链产品碳足迹核算流程</div>
					<!-- <div class="heading-des">
						通过碳核算，组织可以更好地了解和管理其碳足迹，制定减排战略和行动计划
						<br />
						以达到减少温室气体排放的目标，促进可持续发展和应对气候变化
					</div> -->
					<div class="list">
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">企业发起申请</div>
							<!-- <div class="des">企业填报核算相关基础数据、选择碳排因子等</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">企业收集并填报数据</div>
							<!-- <div class="des">测量和计算特定产品碳足迹</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">产品碳足迹核算</div>
							<!-- <div class="des">收集和整理与活动相关的数据，包括能源使用、运输、原材料采购等，用于计算碳排放</div> -->
						</div>
						<div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">生成产品碳足迹核算报告</div>
							<!-- <div class="des">生成碳足迹报告，详细说明排放数据、计算方法和数据来源，向利益相关者和公众披露</div> -->
						</div>
						<!-- <div class="item">
							<svg-icon name="tianbao"></svg-icon>
							<div class="label">核实和认证</div>
							<div class="des">根据需要选择第三方机构</div>
						</div> -->
					</div>
				</div>
			</div>
		</div>
		<!-- 价值 -->
		<div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="worth">
				<div class="worth-container w1200">
					<div class="heading">集装箱产业链产品碳足迹核算价值</div>
					<!-- <div class="heading-des">
						碳足迹核算不仅有助于组织实现经济和环境的双赢，还能提升其在社会和
						<br />
						市场中的形象和竞争力，推动向更可持续的未来迈进
					</div> -->
					<div class="list">
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">应对国际市场需求</div>
							</div>
							<div class="content">
								国际海事组织（IMO）已通过《2023年船舶温室气体减排战略》，明确到2050年前后实现温室气体净零排放。国际主要航运企业制定了净零排放目标，部分航运企业要求提供集装箱产品碳足迹核算报告。
							</div>
						</div>
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">驱动企业管理优化与降本增效</div>
							</div>
							<div class="content">
								精准识别产品全生命周期中碳排放和能源/资源消耗最高的环节，推动生产工艺流程优化和技术改造，实现降碳、节能、降耗与成本节约多重目标的协同。
							</div>
						</div>
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">引领集装箱供应链协同降碳</div>
							</div>
							<div class="content">
								推动上游供应商提供产品碳足迹报告，识别供应链中的高碳排放源头，开展绿色采购，推动集装箱全产业链协同降碳，打造更具竞争力的绿色低碳供应链。
							</div>
						</div>
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">塑造绿色品牌与赢得市场</div>
							</div>
							<div class="content">
								基于国际标准的产品碳足迹数据，是企业发布《环境、社会和公司治理（ESG）》报告的科学、可信基础，展现企业在绿色低碳行动上的透明度和责任感。打造绿色低碳产品，创造市场差异化优势。
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 优势 -->
		<!-- <div class="wow animate__slideInUp" data-wow-duration="1.5s">
			<div class="advantage">
				<div class="advantage-container w1200">
					<div class="heading">碳足迹核算具有多方面的优势</div>
					<div class="heading-des">
						碳足迹核算不仅有助于组织实现经济和环境的双赢，还能提升其在社会和
						<br />
						市场中的形象和竞争力，推动向更可持续的未来迈进
					</div>
					<div class="list">
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">认识和管理风险</div>
							</div>
							<div class="content">
								通过核算碳足迹，组织可以更全面地了解其碳排放的来源和规模，从而识别和管理与碳排放相关的风险。这有助于预测可能面临的气候变化影响，如气候政策变化、碳税或市场需求变化
							</div>
						</div>
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">提升品牌价值和市场竞争力</div>
							</div>
							<div class="content">
								公布和认证的碳足迹数据可以增强组织的透明度和信任度，显示其对环境问题的重视。这对品牌形象有正面影响，也有助于在市场中脱颖而出，特别是在越来越重视可持续性的消费者和投资者中
							</div>
						</div>
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">节约成本和资源</div>
							</div>
							<div class="content">
								通过分析碳足迹，组织可以识别节能减排的机会，采取有效的措施降低能源消耗和碳排放。这些措施通常会带来成本节约，并提高资源利用效率
							</div>
						</div>
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">合规性和法规遵从</div>
							</div>
							<div class="content">
								在许多国家和地区，法律和法规越来越倾向于要求企业报告其碳排放并采取减排措施。通过进行碳足迹核算，企业可以确保符合当地和国际的环境法规，避免潜在的罚款或声誉损失
							</div>
						</div>
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">供应链管理</div>
							</div>
							<div class="content">
								越来越多的组织要求其供应链伙伴也参与减少碳排放的努力。通过要求供应商提供或符合碳足迹数据，可以推动整个供应链的可持续发展，减少整体的环境影响
							</div>
						</div>
						<div class="item">
							<div class="header">
								<svg-icon name="dunpai"></svg-icon>
								<svg-icon name="dunpai2"></svg-icon>
								<div class="label">支持可持续发展目标</div>
							</div>
							<div class="content">
								碳足迹核算是实现可持续发展目标的重要步骤之一。通过管理和减少碳排放，组织不仅可以降低环境影响，还能促进社会责任和可持续性的整体发展
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> -->
		<Foot></Foot>
	</div>
</template>

<script>
	import { webInfo } from '@/common/data.js';
import { SingleSignOnUrl } from '@/common/api.js';
import Head from '@/layout/Head/Head.vue';
import Foot from '@/layout/Foot/Foot.vue';
import { WOW } from 'wowjs';
export default {
	name: 'check',
	components: { Head, Foot },
	data() {
		return {
			// 单点登录地址
			singleSignOnUrl: null,
			fuwuInfo: webInfo.sidafuwu[0]
		};
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			if (vm.checkUser()) {
				vm.getSingleSignOnUrl();
			}
		});
	},
	created() {
		console.log('created');
	},
	activated() {
		console.log('activated');
	},
	mounted() {
		console.log('mounted');
		this.$nextTick(() => {
			new WOW({
				boxClass: 'wow',
				animateClass: 'animate__animated',
				offset: 100,
				mobile: true,
				live: true,
				// callback: function (c) {
				//     console.log(c, 'sss')
				// },
				scrollContainer: null,
				resetAnimation: true
			}).init();
		});
	},
	methods: {
		backHead() {
			this.$router.go(-1);
		},
		// 单点登录地址
		getSingleSignOnUrl() {
			SingleSignOnUrl().then((res) => {
				this.singleSignOnUrl = res.data;
			});
		},
    apply() {
      if (this.checkUser()) {
        if (this.uInfo && this.uInfo.roles && this.uInfo.certifiedStatus == '2') {
          if (this.uInfo.isAdmin) {
            window.open('/org/home/', '_self');
          } else if (
              (!this.uInfo.isAdmin &&
                  this.uInfo.roles &&
                  (this.uInfo.roles.indexOf('manager') != -1 ||
                      this.uInfo.username.indexOf('AdminMaster01') != -1 ||
                      this.uInfo.username.indexOf('AdminMaster02') != -1)) ||
              this.uInfo.roles.indexOf('manager_userSet') != -1
          ) {
            window.open('/org/admin/', '_self');
          } else if (!this.uInfo.isAdmin && this.uInfo.roles && this.uInfo.roles.indexOf('government') != -1) {
            window.open('/org/admin/', '_self');
          } else if (!this.uInfo.isAdmin && this.uInfo.roles && (this.uInfo.roles.indexOf('authentication') != -1 || this.uInfo.roles.indexOf('auth_userSet') != -1)) {
            window.open('/org/authority/', '_self');
          } else if (!this.uInfo.isAdmin && this.uInfo.roles && (this.uInfo.roles.indexOf('company') != -1 || this.uInfo.roles.indexOf('home_userSet') != -1)) {
            window.open('/org/home/', '_self');
          }
        } else if (this.uInfo && this.uInfo.certifiedStatus) {
          if (this.uInfo.certifiedStatus == 1) {
            this.toast({
              type: 'warning',
              message: '实名审核中，请等待审核结果'
            });
          } else if (this.uInfo.certifiedStatus == 2) {
            this.toast({
              type: 'warning',
              message: '暂无进入工作台角色权限，请联系管理员'
            });
          } else if (this.uInfo.certifiedStatus == 3) {
            this.toast({
              type: 'warning',
              message: '实名失败，请重新提交'
            });
          }
        }
      } else {
        this.toast({
          type: 'warning',
          message: '请先登录'
        });
        this.$router.push({
          name: 'login'
        });
      }
    }
	}
};
</script>

<style lang="scss" scoped>
.check-page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	position: relative;
	.banner {
		// margin-top: -$head-height;
		background-image: url('~@/assets/tmp/024.png');
		background-size: cover;
		height: 334px;
		overflow: hidden;
		.content {
			display: flex;
			flex-direction: column;
			padding-left: 50px;
			box-sizing: border-box;
			.heading {
				margin-top: 93px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 36px;
				color: #ffffff;
				line-height: 52px;
			}
			.des {
				margin-top: 17px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 18px;
				color: #ffffff;
				line-height: 22px;
			}
			.btns {
				margin-top: 40px;
				display: flex;
				.lijishiyong {
					display: flex;
					justify-content: center;
					align-items: center;
					padding: 0;
					width: 160px;
					height: 50px;
					border-radius: 0px;
					// font-weight: bold;
					font-size: 16px;
					line-height: 22px;
				}
			}
		}
	}
	.serviceIntroduce {
		background: #f6f8fc;
		padding-bottom: 45px;
		.serviceIntroduce-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 40px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				width: 1166px;
				line-height: 30px;
				margin-top: 20px;
				// width: 986px;
				font-size: 18px;
				color: #636d7e;
				text-align: justify;
				text-align-last: center;
			}

		}
	}
	.steps {
		.steps-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 40px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				margin-top: 20px;
				font-size: 18px;
				color: #636d7e;
				line-height: 25px;
				text-align: center;
			}
			.list {
				align-self: stretch;
				margin-top: 56px;
				margin-bottom: 45px;
				display: flex;
				.item {
					// width: 215px;
					flex: 1;
					padding-left: 15px;
					padding-right: 15px;
					display: flex;
					flex-direction: column;
					align-items: center;
					.svg-tianbao {
						width: 70px;
						height: 70px;
					}
					.label {
						margin-top: 27px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						font-size: 24px;
						color: #262729;
						line-height: 33px;
					}
					.des {
						margin-top: 20px;
						font-size: 14px;
						color: #636d7e;
						line-height: 20px;
						text-align: justify;
						text-align-last: center;
					}
				}
			}
		}
	}
	.worth {
		background: #f6f8fc;
		.worth-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 54px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				margin-top: 14px;
				font-size: 18px;
				color: #636d7e;
				line-height: 25px;
				text-align: center;
			}
			.list {
				margin-top: 50px;
				margin-bottom: 50px;
				margin-left: -12px;
				margin-right: -12px;
				display: flex;
				flex-wrap: wrap;
				.item {
					cursor: default;
					margin-top: 12px;
					margin-bottom: 12px;
					margin-left: 12px;
					margin-right: 12px;
					display: flex;
					flex-direction: column;
					// width: 384px;
					height: 209px;
					background: #ffffff;
					border-radius: 23px;
					padding: 0 16px;
					box-sizing: border-box;
					transition: all 0.5s ease;
					width: calc((100% - (12px * 4)) / 2);
					&:hover {
						background: $primary;
						.header {
							.svg-dunpai {
								display: none;
							}
							.svg-dunpai2 {
								display: block;
							}
							.label {
								color: #ffffff;
							}
						}
						.content {
							color: #ffffff;
						}
					}
					.header {
						display: flex;
						align-items: center;
						padding: 21px 0 11px;
						border-bottom: 1px solid rgba(#cddcf7, 0.2);
						.svg-dunpai {
							width: 47px;
							height: 47px;
							margin-right: 17px;
							display: block;
						}
						.svg-dunpai2 {
							width: 47px;
							height: 47px;
							margin-right: 17px;
							display: none;
						}
						.label {
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 20px;
							color: $primary;
							line-height: 28px;
						}
					}
					.content {
						margin-top: 11px;
						font-size: 14px;
						color: #636d7e;
						line-height: 20px;
						text-align: justify;
					}
				}
			}
		}
	}
	.advantage {
		background: #f6f8fc;
		.advantage-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			.heading {
				margin-top: 54px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				font-size: 28px;
				color: #000000;
				line-height: 52px;
			}
			.heading-des {
				margin-top: 14px;
				font-size: 18px;
				color: #636d7e;
				line-height: 25px;
				text-align: center;
			}
			.list {
				margin-top: 50px;
				margin-bottom: 50px;
				margin-left: -12px;
				margin-right: -12px;
				display: flex;
				flex-wrap: wrap;
				.item {
					cursor: default;
					margin-top: 12px;
					margin-bottom: 12px;
					margin-left: 12px;
					margin-right: 12px;
					display: flex;
					flex-direction: column;
					width: 384px;
					height: 209px;
					background: #ffffff;
					border-radius: 23px;
					padding: 0 16px;
					box-sizing: border-box;
					transition: all 0.5s ease;
					&:hover {
						background: $primary;
						.header {
							.svg-dunpai {
								display: none;
							}
							.svg-dunpai2 {
								display: block;
							}
							.label {
								color: #ffffff;
							}
						}
						.content {
							color: #ffffff;
						}
					}
					.header {
						display: flex;
						align-items: center;
						padding: 21px 0 11px;
						border-bottom: 1px solid rgba(#cddcf7, 0.2);
						.svg-dunpai {
							width: 47px;
							height: 47px;
							margin-right: 17px;
							display: block;
						}
						.svg-dunpai2 {
							width: 47px;
							height: 47px;
							margin-right: 17px;
							display: none;
						}
						.label {
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 20px;
							color: $primary;
							line-height: 28px;
						}
					}
					.content {
						margin-top: 11px;
						font-size: 14px;
						color: #636d7e;
						line-height: 20px;
						text-align: justify;
					}
				}
			}
		}
	}
}
</style>
